export const getBackgroundColors = key => props => props.theme.v2.colors.background[key];
